<div class="list-filter-toolbar">
  <div class="list-filter-toolbar__search">
    <i class="material-icons list-filter-toolbar__search-icon">search</i>
    <input type="text" class="list-filter-toolbar__search-input"
      [(ngModel)]="search"
      (input)="onSearchInput()"
      [placeholder]="searchPlaceholder | translate" />
    </div>
    <button type="button"
      class="list-filter-toolbar__chip"
      [class.list-filter-toolbar__chip--active]="hideShared"
      [attr.aria-pressed]="hideShared"
      (click)="toggleHideShared()">
      <i class="material-icons list-filter-toolbar__chip-icon">group</i>
      <span class="list-filter-toolbar__chip-label">{{ hideSharedLabel | translate }}</span>
      @if (hideShared) {
        <i class="material-icons list-filter-toolbar__chip-check">check</i>
      }
    </button>
  </div>
